import { useTranslation } from 'react-i18next'

import { stopPropagation } from '../../../../../utils/events'
import Button, { BUTTON_HEIGHT_32 } from '../../../../Button'
import { useWidgetContext } from '../../../../Widget'
import { REQUEST_PROFILE_WIDGET_PROVIDERS_ADD_SELECTED_PROVIDER_QA_NAME } from '../RequestProfileWidgetProviders.constants'

import * as styles from './RequestProfileWidgetProvidersSelectedProvidersAddButton.module.css'

import PlusIcon from '../../../../../icons/plus.svg'

function RequestProfileWidgetProvidersSelectedProvidersAddButton({
  className = styles.RequestProfileWidgetProvidersSelectedProvidersAddButton,
}) {
  const { t } = useTranslation()

  const { handleEnableEditMode } = useWidgetContext()

  function handleClick(event) {
    stopPropagation(event)

    handleEnableEditMode()
  }

  return (
    <Button.Outlined
      isGrey
      beforeIconProps={{ Icon: PlusIcon }}
      className={className}
      height={BUTTON_HEIGHT_32}
      qaName={REQUEST_PROFILE_WIDGET_PROVIDERS_ADD_SELECTED_PROVIDER_QA_NAME}
      tooltip={t('RequestProfile.ProvidersWidgetAddButtonTooltipKey')}
      onClick={handleClick}
    />
  )
}

export default RequestProfileWidgetProvidersSelectedProvidersAddButton
